/**
 * @generated SignedSource<<a90300bebd6a4f434bcecec33d323113>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesOrderInlineFragment$data = {
  readonly salesOrderItems: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"salesOrderItemInlineFragment">;
  }>;
  readonly paymentIns: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"paymentInInlineFragment">;
  }>;
  readonly eventGuest: {
    readonly " $fragmentSpreads": FragmentRefs<"eventSalesOrderInlineFragment">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderBaseInlineFragment" | "salesOrderAmountInlineFragment" | "salesOrderPaymentsInlineFragment">;
  readonly " $fragmentType": "salesOrderInlineFragment";
};
export type salesOrderInlineFragment$key = {
  readonly " $data"?: salesOrderInlineFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"salesOrderInlineFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "salesOrderInlineFragment"
};

(node as any).hash = "670cc7ac4fc71a7917b8bd93d8f6676f";

export default node;
